module.exports = __webpack_public_path__ + "img/Price Tracking.3cfdf5bd.svg";